import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { makeMove } from '../../../components/tv-channels/channelController'
import { tvWidgetColors } from '../../JS/colorConfig'
import { setCurrentTV } from '../../../action/tvChannelAction'
import { setGoHome } from '../../action/homeAction'
import {withTranslation} from "react-i18next";
import { CMSPath } from "../../../config/constant"
import { ReactComponent as HomeIcon } from "../../images/icons/house.svg";
import { getCdnUrl } from '../../../config/config'


class TVButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            numberPad: false,
            mute: false,
            pause: false
        }
    }

    componentDidMount() {
        // tvWidgetColors(this.props.menuColor);
    }
    componentDidUpdate() {
        // tvWidgetColors(this.props.menuColor);
    }
    sendCommand = (command) => {
        console.log("sendCommand")
        navigator.vibrate(100)
         
        let token = this.getToken()
        if (token) {
            makeMove(token, command);
        }
    }

    muteClick = () => {
        console.log("muteClick")
        this.setState({ mute: !this.state.mute })
        this.sendCommand(["MUTE"])
    }

    puasePlayButton = () => {
        if (this.state.pause) {
            this.setState({ pause: false })
            this.sendCommand(["PLAY"])
        } else {
            this.setState({ pause: true })
            this.sendCommand(["PAUSE"])
        }
    }

    getToken = () => {
        let token = null
        if (this.props.roomRemoteDetails.length > 0) {
            if (!this.props.currentTv.remoteSessionToken) {
                if (this.props.roomRemoteDetails.length === 1) {
                    this.props.setCurrentTV(this.props.roomRemoteDetails[0]);
                    token = this.props.roomRemoteDetails[0].remoteSessionToken
                    console.log('getToken if', token);
                } else {
                    //this.props.popupOpenClose(true, "Please select your TV In TV section.");
                }
            } else {
                token = this.props.currentTv.remoteSessionToken
                console.log('getToken else', token);
            }
        } else {
            //this.props.popupOpenClose(true, "No TVs to control are found.");
            console.log("No TVs to control are found");
        }
        console.log('getToken', token);
        return token
    }

    goToNumbers = () => {
        this.setState({ numberPad: !this.state.numberPad })
    }

    goBack = () => {
        console.log('this.props.roomRemoteDetails.length',this.props.roomRemoteDetails.length)
        if(this.props.roomRemoteDetails.length <= 1){
            this.props.setGoHome(true);
        } else {
            // window.history.back(-1);
            this.props.setCurrentTV({})
        }
    }

    render() {
        const { t } = this.props
        return (
            <Fragment>
                <header class="inner-pages w-footer subpages"  style={{
                    backgroundColor: this.props.menuColor.assetBackgroundSelectorColor
                }}>
                    {/* <a onClick={() => this.props.setCurrentTV({})} class="button-back"></a> */}
                    <a onClick={this.goBack} class="button-back"></a>
                    <div class="heading align-center">
                        <div class="splash-brand">
                            <img src={getCdnUrl(CMSPath, this.props.logo)} />
                        </div>
                        {/* <p class="bold" style={{
                            color:this.props.menuColor.assetFontSelectorColor,
                            textShadow:"unset"
                        }}>{t('room_control.tv_control.header')}</p> */}
                    </div>
                </header>
                <section id="tvControls" class="widgets padding-0 margin-0 container-bg tvButtons">

                    <div class="widget-header widget-header-checkin">
                        { this.props.currentWidget.widgetHeaderImageUrl && 
                            <div class="widget-header-img">
                                <img src={`${CMSPath}${this.props.currentWidget.widgetHeaderImageUrl}`} alt={this.props.currentWidget.displayName} />
                            </div>
                        }
                        <div class="widget-header-title">{t('room_control.tv_control.header')}</div>
                    </div>


                    <div class="widgets">
                        <div class="row padding-left-2 padding-right-2">
                            <button onClick={() => { this.sendCommand(["POWER"]) }} class="power"><i class="power-on fas fa-power-off"></i></button>
                        </div>
                        <div class="row padding-left-2 padding-right-2">
                            <div class="col">
                                <div class="form-controls radio-controls">
                                    <div class="radio-group">
                                        <label class="radio"><input type="radio" name="tv-mode" value="TV" />
                                            <span onClick={() => { this.sendCommand(["TV"]) }} class="radio-label">TV</span>
                                        </label>
                                        <label class="radio"><input type="radio" name="tv-mode" value="Stream" />
                                            <span onClick={() => { this.sendCommand(["CC"]) }} class="radio-label">CC</span>
                                        </label>
                                        <label class="radio"><input type="radio" name="tv-mode" value="Apps" />
                                            <span onClick={() => { this.sendCommand(["TV"]) }} class="radio-label">Hotel</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="chDpad" class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1 ch-dpad">
                            <div class="ch-buttons ch-opt-buttons">
                                <button onClick={() => { this.sendCommand(["BACK"]) }} class="ch-back">
                                    <span class="button-label">Back</span>
                                    <svg className='button-background' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57.31 57.34"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M.5,56s5.35,2,9.57,0c0,0,30.13-35.76,46.74-40.27V3.32A3.11,3.11,0,0,0,53.71.5H20.49S.5,2.75.5,25.56Z" /></g></g></svg>
                                </button>
                                <button onClick={() => { this.sendCommand(["HOME"]) }} class="ch-home right-align">
                                    {/* <!-- <span class="button-label">Home</span> --> */}
                                    <HomeIcon />
                                    <svg className='button-background' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57.31 57.34"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M.5,56s5.35,2,9.57,0c0,0,30.13-35.76,46.74-40.27V3.32A3.11,3.11,0,0,0,53.71.5H20.49S.5,2.75.5,25.56Z" /></g></g></svg>
                                </button>
                            </div>
                            <div class="ch-buttons ch-dpad-buttons">
                                <div class="ch-buttons-nav nav-single">
                                    <button style={{ color: "inherit" }} onClick={() => { this.sendCommand(["UP"]) }} class="nav-up">
                                        <i style={{ color: "inherit" }} class="fas fa-play"></i>
                                    </button>
                                </div>
                                <div class="ch-buttons-nav ch-dpad-main" style={{height: "auto"}}>
                                    <button style={{ color: "inherit" }} onClick={() => { this.sendCommand(["LEFT"]) }} class="nav-left">
                                        <i style={{ color: "inherit" }} class="fas fa-play"></i>
                                    </button>
                                    <button style={{ color: "inherit" }} onClick={() => { this.sendCommand(["ENTER"]) }} class="nav-ok">OK</button>
                                    <button style={{ color: "inherit" }} onClick={() => { this.sendCommand(["RIGHT"]) }} class="nav-right">
                                        <i style={{ color: "inherit" }} class="fas fa-play"></i>
                                    </button>
                                </div>
                                <div class="ch-buttons-nav nav-single">
                                    <button style={{ color: "inherit" }} onClick={() => { this.sendCommand(["DOWN"]) }} class="nav-down">
                                        <i style={{ color: "inherit" }} class="fas fa-play"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="ch-buttons ch-opt-buttons">
                                <button onClick={() => { this.sendCommand(["MENU"]) }} class="ch-menu">
                                    <span class="button-label">Menu</span>
                                    <svg className='button-background' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57.31 57.34"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M.5,1.38s5.35-2,9.57,0c0,0,30.13,35.75,46.74,40.26V54a3.1,3.1,0,0,1-3.1,2.81H20.49S.5,54.59.5,31.78Z" /></g></g></svg>
                                </button>
                            </div>
                        </div>
                        {!this.state.numberPad ?
                            <div id="chControls" class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1 ch-controls">
                                <div class="col ch-buttons ch-vertical">
                                    <div class="button-container" style={{
                                        backgroundColor: this.props.menuColor.assetBackgroundSelectorColor,
                                        color: this.props.menuColor.assetFontSelectorColor,
                                    }}>
                                        <button style={{ backgroundColor: "inherit", color: "inherit" }} onClick={() => { this.sendCommand(["VOL_UP"]) }}><i class="fas fa-plus"></i></button>
                                        <span class="button-label">VOL</span>
                                        <button style={{ backgroundColor: "inherit", color: "inherit" }} onClick={() => { this.sendCommand(["VOL_DOWN"]) }}><i class="fas fa-minus"></i></button>
                                    </div>
                                </div>
                                <div class="col ch-buttons ch-circle">
                                    <button onClick={this.goToNumbers} className="button-label">123</button>
                                    <button onClick={this.muteClick}>
                                        {this.state.mute ?
                                            <i class="fas fa-volume-mute"></i> :
                                            <i class="fas fa-volume-up"
                                            // style="display: none;"
                                            ></i>
                                        }
                                    </button>
                                </div>
                                <div class="col ch-buttons ch-vertical">
                                    <div class="button-container" style={{
                                        backgroundColor: this.props.menuColor.assetBackgroundSelectorColor,
                                        color: this.props.menuColor.assetFontSelectorColor,
                                    }}>
                                        <button style={{ backgroundColor: "inherit", color: "inherit" }} onClick={() => { this.sendCommand(["CH_UP"]) }}><i class="fas fa-plus"></i></button>
                                        <span class="button-label">CH</span>
                                        <button style={{ backgroundColor: "inherit", color: "inherit" }} onClick={() => { this.sendCommand(["CH_DOWN"]) }}><i class="fas fa-minus"></i></button>
                                    </div>
                                </div>
                            </div>
                            :
                            <div id="numControls">
                                <div id="chControls" class="row padding-right-1 padding-left-1 ch-controls padding-bottom-0">
                                    <div class="col ch-buttons ch-circle">
                                        <button onClick={this.goToNumbers}><i class="fas fa-times"></i></button>
                                    </div>
                                </div>
                                <div id="numPad" class="row padding-bottom-1 padding-right-1 padding-left-1 ch-controls ch-num-pad">
                                    <div class="ch-num-pad-row">
                                        <button onClick={() => { this.sendCommand(["1"]) }}>1</button>
                                        <button onClick={() => { this.sendCommand(["2"]) }}>2</button>
                                        <button onClick={() => { this.sendCommand(["3"]) }}>3</button>
                                    </div>
                                    <div class="ch-num-pad-row">
                                        <button onClick={() => { this.sendCommand(["4"]) }}>4</button>
                                        <button onClick={() => { this.sendCommand(["5"]) }}>5</button>
                                        <button onClick={() => { this.sendCommand(["6"]) }}>6</button>
                                    </div>
                                    <div class="ch-num-pad-row">
                                        <button onClick={() => { this.sendCommand(["7"]) }}>7</button>
                                        <button onClick={() => { this.sendCommand(["8"]) }}>8</button>
                                        <button onClick={() => { this.sendCommand(["9"]) }}>9</button>
                                    </div>
                                    <div class="ch-num-pad-row">
                                        <button onClick={this.puasePlayButton}>
                                            <i class="fas fa-play"></i> / <i class="fas fa-pause"></i>
                                        </button>
                                        <button onClick={() => { this.sendCommand(["0"]) }}>0</button>
                                        <button onClick={() => { this.sendCommand(["SLEEP"]) }}>SLEEP</button>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </section>

            </Fragment>        )
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentWidget: state.store.sideNavBar.currentWidget,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        showTVLogin: state.store2.TVControl.showLogin,
        roomRemoteDetails: state.store.tvChannels.roomRemoteDetails,
        currentTv: state.store.tvChannels.currentTv,
        menuColor: state.store.home.MenuColor,
    }
}
export default connect(
    mapStateToProps,
    {
        setCurrentTV,
        setGoHome
    }
)(withTranslation('translations')(TVButton));